import React, { useEffect, useRef, useState } from "react";
import "./LiveCardVideo.css";
import posterImg from "../image/loadingshimmer.png";

import { MdKeyboardArrowRight } from "react-icons/md";
import sampleVideo from '../image/temp.mp4';
import { FaRegHeart } from "react-icons/fa";
import save from '../image/save.svg';
import share from '../image/share.svg';
import like from '../image/like.svg';
import { IoVolumeMuteOutline } from "react-icons/io5";
import { GoUnmute } from "react-icons/go";
import ShareModal from "./ShareModal";
import { tr } from "date-fns/locale";
import { Link } from "react-router-dom";

const LiveCardVideo = ({ data, }) => {

  const url = "https://partywitty.com/master/assets/uploads/";
  const videoRef = useRef(null);

  // Local state synced with localStorage
  const [isMuted, setIsMuted] = useState(() => {
    const stored = localStorage.getItem("isMuted");
    return stored ? JSON.parse(stored) : true;
  });

  const [isVisible, setIsVisible] = useState(false);


  // Handle mute toggle
  const handleMute = () => {
    const newMute = !isMuted;
    localStorage.setItem("isMuted", JSON.stringify(newMute));
    setIsMuted(newMute);
  };

  // Watch visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.6 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  // Control video playback and mute state
  useEffect(() => {
    const video = videoRef.current;
    const stored = localStorage.getItem("isMuted");
    console.log("stored", stored);
    if (video) {
      video.muted = stored === "true" ? true : false;
      if (isVisible) {
        video.play().catch(() => { });
      } else {
        video.pause();
      }
    }
  }, [isVisible, isMuted]);

  return (
    <>
      <div className="v-card">
        {/* Header */}
        <div className="v-card-header">
          <img
            className="v-profile-img"
            src={url + data?.clubLogo}
            alt="Club"
          />
          <div className="v-header-text">
            <h4>
              {/* <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName)}> */}
              {data?.clubName}
              {/* </Link> */}
            </h4>
            <p>{data?.title}</p>
          </div>
          <div className="v-dots"
          //  onClick={(e) => handleShare(e, data)}
          >•••</div>
        </div>


        {/* Offer strip */}
        <div className="v-offer-strip">
          Add On up to 50% Extra on Food & Beverages
        </div>
        {/* Banner */}
        <div className="v-card-banner">
          <video
            ref={videoRef}
            src={url + data?.video}
            poster={posterImg}
            autoPlay
            muted={localStorage.getItem("isMuted") === "true" ? true : false}
            loop
            playsInline
            className="live-card-video"
          >
            <source src={url + data?.video} type="video/mp4" />
          </video>
          <div className="v-label-banner">{data?.category}</div>

          <div className="v-label-banner-mute-unmute" onClick={handleMute}> {localStorage.getItem("isMuted") === "true" ? <IoVolumeMuteOutline size={20} /> : <GoUnmute size={20} />} </div>
        </div>


        {/* CTA Button */}
        <Link to="/package-lead-form">
          <div className="v-cta-button">Reserve Now <span className="v-arrow-icon-live"><MdKeyboardArrowRight /></span></div>
        </Link>

        <div className="v-card-icons">

          <div className="v-card-icons-right">
            <div>
              <img src={like} alt="" />
            </div>
            <div>
              <img src={share} alt="" />
            </div>
          </div>

          <div>
            <img src={save} alt="" />
          </div>
        </div>

        {/* Footer */}
        <div className="v-card-footer">
          <p>❤️ Liked by XYZ Club and others</p>
          <div className="v-icons">
            <span>🔗</span>
            <span>🔖</span>
          </div>
        </div>
      </div>
      {/* <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentShareUrl}
        title={shareTitle}
      /> */}
    </>
  );
};

export default LiveCardVideo;
